<template>
  <div>
         <stepheader :step="step"/>
        <div id="wizard2-p-0" role="tabpanel" aria-labelledby="wizard2-h-0" class="body current" aria-hidden="false" style="">
          <div class="row">
           <div class="col-6">
           <label class="form-label" for="dataevento">
Indica la data dell'evento: <span class="tx-danger">*</span></label>
           <input type="date" id="dataevento" v-model="dataevento" class="form-control">
            </div>
        
        <div class="col-6">
           <label class="form-label" for="oraevento">Indica l'ora dell'evento: <span class="tx-danger">*</span></label>
           <input type="time" id="oraevento" v-model="oraevento" class="form-control">
            </div>
          </div>
          <buttons :buttons=step.buttons v-on:action="fireaction"></buttons>
											
 
  </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";
import moment from "moment"
export default {
  name: "dataevento",

  props: {
    step: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  ticket: {
      type: Object,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
     oraevento:"00:00",
     dataevento:null
    };
  },
  computed: {
   
  },
  components: {
   
  },
  mounted() {
    if(this.ticket && this.ticket.dataEvento){
var d = moment(this.ticket.dataEvento)
      this.dataevento = d.format("yyyy-MM-dd");
      this.oraevento = d.format("HH:mm");
    }
  },
  methods: {
    fireaction:function(action,nextstep){
      switch(action){
        case "next":
           if(!this.dataevento){

         swal({
              title: "Errore di compilazione",
              text: "Inserire la data dell'accaduto",
              type: "error",
              showCancelButton: false,
              toast: false,
               timer: 2000, 
              showConfirmButton: false,
              position: "bottom-top",
            });

           }
           else{
            var m = moment(this.dataevento+"T"+this.oraevento);
            if(m.isAfter(new moment())){
 swal({
              title: "Errore di compilazione",
              text: "Attenzione, la data dell'accaduto non può essere nel futuro",
              type: "error",
              showCancelButton: false,
              toast: false,
               timer: 2000, 
              showConfirmButton: false,
              position: "bottom-top",
            });
return;
            }

            this.ticket.dataEvento = this.dataevento+"T"+this.oraevento;
  this.$emit("goto",nextstep);

           }
          break;
default:
   this.$emit("goto",nextstep);
  break;
      }

    },
   loaddata: function () {
    
    },

    authenticate:function(nextstep){

    }
  },
};
</script>